<template>
  <div
    ref="detail"
    class="invite-detail"
    :class="{'scrolled': this.scrolled, 'show-popup': this.showPopup || this.showCheckPopup}"
    v-on:scroll.passive="handleScroll"
  >
    <div class="header" :class="{'posiFix': this.scrolled}">
      <div class="header-inner">
        <div class="row top" :class="{'posiFix': this.scrolled}">
          <h2
            class="col-9 title"
          >{{this.inviteData.priVisitorName}} {{this.inviteData.visitTypeName}} {{this.inviteData.areaName}}</h2>
          <div class="col-3">
            <div class="go-back" @click="routeChange()" v-if="backPath !='/'">
              <i class="iconfont icon-close"></i>
            </div>
          </div>
        </div>
        <div class="header-content">
          <div class="apply-status">{{$t('ApplyStatus')}}：{{this.inviteData.checkStatusDesc}}</div>
          <div
            class="dock-number"
            v-if="this.inviteData.dockNumber"
          >{{$t('DockNumber')}}：{{this.inviteData.dockNumber}}</div>

          <div
            class="time"
          >{{$t('visitTime')}}{{this.inviteData.visitDay}} {{this.inviteData.visitStartTime}} - {{this.inviteData.visitDay}} {{this.inviteData.visitEndTime}}</div>
          <div class="apply-time">{{$t('expectedTimePeriod')}}：{{this.inviteData.schedule}}</div>
          <div class="approver-people" v-if="this.inviteData.approver">{{$t('approver')}}：{{this.inviteData.approver}}</div>
          <div class="approver-time" v-if="this.inviteData.approveTime">{{$t('approveTime')}}：{{this.inviteData.approveTime}}</div>
          <div class="bottler-order" v-if="bottlerList && bottlerList.length">
            <div class="bottler-l">{{$t('bottler')}}/{{$t('OrderNumber')}}：</div>
            <div class="bottler-r">
              <p v-for="(item, index) in bottlerList" :key="index">{{item.bottlerName}}<span v-if="item.orderNumber">/</span>{{item.orderNumber}} </p></div>
            </div>
          <div class="company-name" v-if="companyName">{{$t('companyName')}}：{{companyName}}</div>
        </div>
      </div>
      <div class="header-bg"></div>
    </div>
    <div class="content">
      <div class="visitor-list-wrapper">
        <div class="view-main">
          <div class="visitor-list">
            <div class="view-header visiteInformation">
              <h4>{{$t('VehicleInformation')}}</h4>
            </div>
            <div class="view-content"  v-if="inviteData.carList && inviteData.carList.length>0">
              <div class="visitor-row" :key="index" v-for="(item, index) in inviteData.carList">
                <div class="detail-info">
                  <div class="row first" v-if="item.carNumber">
                    <div class="col-5 l">{{$t("numberPlate")}}</div>
                    <div class="col-7 red">{{item.carNumber}}</div>
                  </div>
                  <div class="row" v-if="item.carType">
                    <div class="col-5 l">{{$t("VehicleType")}}</div>
                    <div class="col-7">{{item.carType}}</div>
                  </div>
                  <div class="row" v-if="item.tonnage">
                    <div class="col-5 l">{{$t("Tonnage")}}</div>
                    <div class="col-7">{{item.tonnage}}</div>
                  </div>
                  <div class="row" v-if="item.accompanyingVisitors.length">
                    <div class="col-5 l">{{$t("AccompanyingVisitors")}}</div>
                    <div class="col-7">
                      <div
                        class="row-visitors"
                        v-for="(v, index) in item.accompanyingVisitors"
                        :key="v.visitorName+index+v.account"
                      >{{v.visitorName}} {{v.account}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="car-list-des" v-else>
              {{$t('noCarList')}}
            </div>
          </div>
        </div>
        <div class="handle-bar fixed-bottom row" v-if="this.inviteData.hasApprovalAuthority">
          <div class="col-6 refuse">
            <button class="btn btn-default" @click="showReason">{{$t('reject')}}</button>
          </div>
          <div class="col-6 approve">
            <button class="btn btn-gradient" @click="showConfirm">{{$t('realConfirm')}}</button>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="reason" v-show="showPopup">
        <div class="reson-inner" :class="{ focused: isKeyboardUp }">
          <i class="iconfont icon-close" @click="showPopup = false; textareaAddNodes = '';"></i>
          <h4>{{$t('reason')}}</h4>
          <p>{{$t('pleaseFillReason')}}</p>
          <div class="form-group">
            <textarea rows="3" :placeholder="$t('pleaseFillReason')" v-model="textareaAddNodes"/>
            <label class="error-msg" v-show="errorTextarea">{{$t('pleaseFillReason')}}</label>
          </div>
          <div class="form-action row">
            <!-- <div class="col-6">
              <button class="btn btn-default" @click="showPopup = false">{{$t('Cancel')}}</button>
            </div>-->
            <div class="col-12">
              <button class="btn btn-gradient" @click="commitReason">{{$t('confirm')}}</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="confirm" v-show="showCheckPopup">
        <div class="confirm-inner">
          <i class="iconfont icon-close" @click="showCheckPopup = false"></i>
          <h4>{{$t('realConfirm')}}</h4>
          <div class="form">
            <div class="form-item row">
              <div class="col-4">{{$t('VisitDate')}}</div>
              <div class="col-6">
                <div class="invisitTime">
                  <dateTimePicker
                    :hasclass="'no-style1'"
                    :isStartDate="true"
                    :type="'date'"
                    v-model="startEndDate"
                    :placeholder="$t('pleaseSelectAccessTime')"
                    @change="handleDateChange"
                  ></dateTimePicker>
                  <i class="iconfont icon-down"></i>
                </div>
                <label class="error-msg" v-show="errorMsgDate">{{$t('fillAppointmentDate')}}</label>
              </div>
            </div>
            <div class="form-item row">
              <div class="col-4">{{$t('expectedTimePeriod')}}</div>
              <div class="col-6">
                <div class="select-time-con">
                  <div class="select-time" @click="GetScheduleList()">
                    <input
                      v-model="scheduleValue.scheduleName"
                      :placeholder="$t('fillExpectedTimePeriod')"
                      readonly
                    >
                    <i class="iconfont icon-down"></i>
                  </div>
                  <ul v-show="this.scheduleShow">
                    <li
                      v-for="(item) in scheduleList"
                      :key="item.scheduleName"
                      @click="handleScheduleChange(item)"
                      :class="{ selectActive:item.scheduleId == scheduleValue.scheduleId }"
                    >{{item.scheduleName}}</li>
                  </ul>
                </div>
                <label class="error-msg" v-show="errorMsgSchedule">{{$t('fillExpectedTimePeriod')}}</label>
              </div>
            </div>
            <div class="form-item row">
              <div class="col-4">{{$t('interviewTime')}}</div>
              <div class="col-6">
                <div class="startEndTime">
                  <input
                    type="text"
                    :placeholder="'text'"
                    @click="openPicker1"
                    v-model="selectedStartTime"
                    readonly
                  > -
                  <input
                    type="text"
                    :placeholder="'text'"
                    @click="openPicker2"
                    v-model="selectedEndTime"
                    readonly
                  >
                  <input
                    ref="picker1"
                    v-model="startTime"
                    type="time"
                    data-role="date-picker1"
                    class="input-hidden"
                  >
                  <input
                    ref="picker2"
                    v-model="endTime"
                    type="time"
                    data-role="date-picker2"
                    class="input-hidden"
                  >
                  <label class="error-msg" v-show="errorMsgDate2">{{$t('fillVisitTime')}}</label>
                </div>
              </div>
            </div>
            <div class="form-item row">
              <div class="col-4">{{$t('dockNumer')}}</div>
              <div class="col-6">
                <div class="select-dock-con">
                  <div class="select-dock" @click="GetDockList()">
                    <input
                      v-model="dockValue.dockNumber"
                      :placeholder="$t('pleaseFillDock')"
                      readonly
                    >
                    <i class="iconfont icon-down"></i>
                  </div>
                  <div class="dock-list" v-show="this.dockShow">
                    <ul>
                      <li
                        v-for="(item) in dockList"
                        :key="item.dockNumber"
                        @click="handleDockChange(item)"
                        :class="{ selectActive:item.dockId == dockValue.dockId }"
                      >{{item.dockNumber}}</li>
                    </ul>
                  </div>
                  <label class="error-msg" v-show="errorMsgDock">{{$t('pleaseFillDock')}}</label>
                </div>
              </div>
            </div>
            <div class="form-action">
              <button class="btn btn-default" @click="showCheckPopup = false">{{$t('Cancel')}}</button>
              <button class="btn btn-gradient" @click="commitConfirm">{{$t('confirm')}}</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <alertModal
      :modalType="'simple'"
      :isModalShown="isShowError"
      :modalTitle="isMessage"
      @cancel="isShowError = !isShowError"
    ></alertModal>
    <alertModal
      :modalType="'simple'"
      :isModalShown="isDeleteOrNoAuthority"
      :modalTitle="isErrorMes"
      @cancel="goToListPage()"
    ></alertModal>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
  </div>
</template>

<script>
import dateTimePicker from "@/components/dateTimePicker.vue";
import {
  getCarrierInvitationDetail,
  rejectCarrierTicket,
  getDockList,
  getScheduleList,
  confirmCarrierTicket
} from "@/utils/api";
import { checkNested } from "@/utils/utils";
import alertModal from "@/components/alertModal.vue";
import "mint-ui/lib/style.css";
import { DatetimePicker } from "mint-ui";
import Vue from "vue";
import Moment from "moment";
import Loading from "vue-loading-overlay";
import '../../utils/mobiscroll';
import '../../utils/mobiscroll.css';
import $ from 'jquery';
Vue.component(DatetimePicker.name, DatetimePicker);
const MobileDetect = require("mobile-detect");
const md = new MobileDetect(window.navigator.userAgent);
const isiPhone = md.is("iPhone");
export default {
  name: "approvalDetail",
  components: {
    alertModal,
    dateTimePicker,
    Loading
  },
  data() {
    return {
      inviteData: {},
      isLoading: false,
      scrolled: false,
      showPopup: false,
      showCheckPopup: false,
      textareaAddNodes: "",
      isKeyboardUp: false,
      isShowError: false,
      startEndDate: "",
      dockList: [],
      scheduleList: [],
      dockValue: "",
      scheduleValue: "",
      dockShow: false,
      scheduleShow: false,
      startTime: "",
      selectedStartTime: "",
      endTime: "",
      selectedEndTime: "",
      isMessage: "",
      errorMsgDate: false,
      errorMsgDate2: false,
      errorMsgDock: false,
      errorMsgSchedule: false,
      errorTextarea: false,
      backPath: "",
      isDeleteOrNoAuthority: false,
      isErrorMes: '',
      bottlerList: [],
      companyName: '',
      opt: {
        preset: 'time',
        timeFormat: 'HH:ii',
        stepMinute: 1,
        setText: '确认',
        cancelText: '取消',
        hourText:'小时',
        minuteText:'分',
      }
    };
  },
  mounted() {
    this.initMobiscrollTime('picker1', this.handleConfirm1, 'date-picker1');
    this.initMobiscrollTime('picker2', this.handleConfirm2, 'date-picker2');
  },
  created() {
    const routeID = this.$route.params.id;
    this.routId = routeID;
    this.backPath = sessionStorage.getItem("backPath");
    // top detail
    this.GetCarrierInvitationDetail(routeID);
  },
  methods: {
    goToListPage() {
       this.$router.push({ path: "/carrier/invitationlist/0" });
    },
    routeChange() {
      this.$router.push({
        path: this.backPath
      });
    },
    GetCarrierInvitationDetail(routeID) {
      this.isLoading = true;
      getCarrierInvitationDetail(routeID)
        .then(res => {
          this.isLoading = false;
          if (checkNested(res, "data", "content", "model")) {
            if (res.data.content.model) {
              this.inviteData = res.data.content.model;
              this.startEndDate = this.inviteData.visitDay;
              this.selectedStartTime = this.inviteData.visitStartTime;
              this.selectedEndTime = this.inviteData.visitEndTime;
              this.bottlerList = this.inviteData.bottlerList;
              this.companyName = this.inviteData.companyName;
              if (this.inviteData.ifEnable == false) {
                this.isDeleteOrNoAuthority = true;
                this.isErrorMes = this.$t('hasDelete');
              }
              this.dockValue = {
                dockId: this.inviteData.dockId,
                dockNumber: this.inviteData.dockNumber
              };
              this.scheduleValue = {
                scheduleId: this.inviteData.scheduleId,
                scheduleName: this.inviteData.schedule
              };
              console.log("详情信息");
              console.log(this.inviteData);
            } else {
              this.isDeleteOrNoAuthority = true;
              this.isErrorMes = res.data.content.message;
            }
          }
        })
        .catch(err => {
          this.isDeleteOrNoAuthority = true;
          this.isErrorMes = res.data.message;
        });
    },
    showReason() {
      const status = this.inviteData.checkStatus;
      const hasVisitorIn = this.inviteData.hasVisitorIn;
      if (hasVisitorIn) {
        this.isShowError = true;
        this.isMessage = this.$t("CantBeRejected");
        return;
      }

      if (status == 3) {
        this.isShowError = true;
        this.isMessage = this.$t("NoNeedToDecline");
      } else {
        this.showPopup = true;
      }
      
    },
    showConfirm() {
      if (this.inviteData.isExpired) {
        this.isShowError = true;
        this.isMessage = this.$t("InvitationExpiredMessage");
        return;
      }

      this.showCheckPopup = true;
    },
    commitReason() {
      const ticketScheduleId = this.inviteData.ticketScheduleId;
      if (this.textareaAddNodes == "") {
        this.errorTextarea = true;
        return;
      }

      const model = {
        ticketScheduleId: ticketScheduleId,
        rejectReason: this.textareaAddNodes
      };
      rejectCarrierTicket(model)
        .then(res => {
          console.log(res);
          if (res.data.content.status == "001") {
            this.showPopup = false;
            this.textareaAddNodes = "";
            this.GetCarrierInvitationDetail(this.routId);
          } else {
            this.isShowError = true;
            this.isMessage = res.data.content.message;
          }
        })
        .catch(err => {
          this.isShowError = true;
          this.isMessage = res.data.message;
        });
    },
    commitConfirm() {
      const model = {
        ticketScheduleId: this.inviteData.ticketScheduleId,
        appointmentDate: this.startEndDate,
        startTime: this.selectedStartTime,
        endTime: this.selectedEndTime,
        dockId: this.dockValue.dockId,
        scheduleId: this.scheduleValue.scheduleId
      };

      if (!this.startEndDate) {
        this.errorMsgDate = true;
      }
      if (!this.selectedStartTime && !this.selectedEndTime) {
        this.errorMsgDate2 = true;
      }

      if (!this.dockValue.dockId) {
        this.errorMsgDock = true;
      }

      if (!this.scheduleValue.scheduleId) {
        this.errorMsgSchedule = true;
      }

      if (
        !this.startEndDate ||
        (!this.selectedStartTime && !this.selectedEndTime) ||
        !this.dockValue.dockId ||
        !this.scheduleValue.scheduleId
      )
        return;

      confirmCarrierTicket(model).then(res => {
        if (res.data.status == "001") {
          console.log(res);
          console.log(res.data.content.status);
          if (res.data.content.status == 1) {
            this.showCheckPopup = false;
            this.GetCarrierInvitationDetail(this.routId);
          } else {
            this.isShowError = true;
            this.isMessage = res.data.content.message;
          }
        } else {
          this.isShowError = true;
          this.isMessage = res.data.message;
        }
      });
    },
    handleScroll() {
      if (
        document.documentElement.clientHeight <
        document.body.clientHeight + 1
      ) {
        this.scrolled = this.$refs.detail.scrollTop != 0;
      }
    },
    handleDateChange(date) {
      const { startEndDate } = this;
      this.startEndDate = startEndDate;
    },
    GetDockList() {
      this.scheduleShow = false;
      if (!this.dockList.length) {
        getDockList().then(res => {
          console.log("docklist", res);
          if (checkNested(res, "data", "content", "model")) {
            if (res.data.content.model) {
              this.dockList = res.data.content.model;
              this.dockShow = true;
              console.log("docklist", this.dockList);
            }
          }
        });
      } else {
        this.dockShow = true;
      }
    },
    GetScheduleList() {
      this.dockShow = false;
      if (!this.scheduleList.length) {
        getScheduleList().then(res => {
          console.log("ScheduleList", res);
          if (checkNested(res, "data", "content", "model")) {
            if (res.data.content.model) {
              this.scheduleList = res.data.content.model;
              this.scheduleShow = true;
            }
          }
        });
      } else {
        this.scheduleShow = true;
      }
    },
    handleDockChange(item) {
      this.dockShow = false;
      this.errorMsgDock = false;
      this.dockValue = item;
    },
    handleScheduleChange(item) {
      this.scheduleShow = false;
      this.errorMsgSchedule = false;
      this.scheduleValue = item;
    },
    handleConfirm1(dateObj) {
      this.selectedStartTime = dateObj;
      this.errorMsgDate2 = false;
    },
    handleConfirm2(dateObj) {
      this.selectedEndTime = dateObj;
      this.errorMsgDate2 = false;
    },
    openPicker1() {
      const time = this.startTime ? this.startTime : this.selectedStartTime;
      const now = new Date();
      const [hours, minutes] = time.split(':');
      const completeDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, now.getSeconds());
      const momentDate =Moment(completeDate).toDate();
      $(this.$refs.picker1).mobiscroll('setDate', momentDate, true);
      $(this.$refs.picker1).mobiscroll('show');
    },
    openPicker2() {
      const time = this.endTime ? this.endTime : this.selectedEndTime;
      const now = new Date();
      const [hours, minutes] = time.split(':');
      const completeDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, now.getSeconds());
      const momentDate =Moment(completeDate).toDate();
      $(this.$refs.picker2).mobiscroll('setDate', momentDate, true);
      $(this.$refs.picker2).mobiscroll('show');
    },
    initMobiscrollTime(refName, handleConfirm, dataRole) {
      const self = this;
      let timerId;

      $(this.$refs[refName]).mobiscroll('destroy').mobiscroll(
        $.extend({}, this.opt, {
          theme: 'mobiscroll',
          mode: 'scroller',
          display: 'modal',
          lang: 'zh',
          animate: 'slidevertical',
          onSelect: (value) => {
            if (value) {
              const [hours, minutes, second] = value.split(':');
              const newValue = `${hours}:${minutes}`
              handleConfirm(newValue);
              console.log(`${refName} value:`, newValue);
            }
          },
          onBeforeShow: (event, inst) => {
            timerId = setInterval(() => {
              const activeElement = document.activeElement;
              if (activeElement && activeElement.getAttribute('data-role') === dataRole) {
                activeElement.blur();
              }
            }, 50);
          },
          onBeforeClose: (event, inst) => {
            clearInterval(timerId);
          },
        })
      );
    },
  }
};
</script>


<style scoped lang="scss">
.bottler-order {
  display: flex;
}
.lang-en {
  .bottler-l {
    min-width: 140px;
  }
}

.bottler-l {
  min-width: 97px;
}

.bottler-r p {
  word-break: break-all;
  margin-bottom: 0;
}
.car-list-des {
  font-size: 14px;
  padding-top: 10px;
  color: #888;
}
.reason,
.confirm {
  display: none;
}
.show-popup,
.show-modal,
.show-status {
  height: 100vh;
  overflow: hidden;
  color: #4a4a4a;
  .reason,
  .confirm {
    display: block;
    width: 100%;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    background: rgba(0, 0, 0, 0.4);
    .icon-close {
      position: absolute;
      top: 10px;
      right: 5%;
      z-index: 10;
      font-size: 22px;
    }
    input {
      color: #434343;
      font-size: 14px;
    }
  }
  .confirm-inner,
  .reson-inner {
    background-color: #fff;
    border-radius: 10px 10px 0 0;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 10;
    padding: 20px 5%;
  }
  .reson-inner {
    &.focused {
      padding-bottom: 300px;
    }
    h4 {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 15px;
    }
    p {
      font-size: 13px;
      margin-bottom: 5px;
    }
    .reson-option {
      margin-bottom: 20px;
    }
    .refuse-reson {
      position: relative;
      text-align: right;
      & > div {
        span {
          color: #4a4a4a;
          font-size: 13px;
        }
      }
      input {
        width: 150px;
        margin-right: 10px;
        font-size: 13px;
        color: #4a4a4a;
        text-align: right;
        margin-right: 5px;
        cursor: pointer;
      }
      ul {
        position: absolute;
        top: 25px;
        right: 21px;
        background: #fff;
        border: 1px solid #929292;
        width: 165px;
        text-align: left;
        li {
          &:hover {
            background: #0074e8;
            color: #fff;
          }
          list-style: none;
          line-height: 24px;
          color: #4a4a4a;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
    textarea {
      width: 100%;
      height: 175px;
      border: none;
      background: #f0f0f0;
      padding: 8px;
      font-size: 13px;
    }
    .form-group {
      margin-bottom: 25px;
    }
    .form-action {
      margin-bottom: 20px;
    }
    .btn {
      width: 100%;
    }
  }
  .confirm-inner {
    padding-bottom: 120px;
    h4 {
      font-size: 20px;
      font-weight: bold;
      line-height: 24px;
      text-align: center;
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: #ccc 1px dashed;
    }
    .invisitTime {
      padding: 0 20px 0 4px;
      border: #ccc 1px solid;
      color: #434343;
      position: relative;
      i {
        position: absolute;
        top: 0;
        right: 3px;
        display: inline-block;
        height: 24px;
        line-height: 24px;
        vertical-align: top;
        border-left: #ccc 1px solid;
        &:before {
          font-size: 8px;
          margin-left: 4px;
          position: relative;
          top: -3px;
        }
      }
    }
    .form-item {
      margin-bottom: 20px;
      padding-left: 20px;
      .col-6 {
        padding: 0;
      }
      .col-4 {
        padding-right: 0;
      }
    }
    .form-action {
      padding-top: 20px;
      text-align: center;
      button {
        font-size: 14px;
        min-width: 80px;
      }
      .btn-default {
        margin-right: 40px;
      }
    }
  }
  .startEndTime {
    input {
      border: #ccc 1px solid;
      width: 60px;
      padding: 0 4px;
      color: #434343;
      appearance: none;
    }
  }
}
.error-msg {
  color: #e42029;
  font-size: 12px;
  margin-bottom: 0;
  display: block;
}
.form {
  max-width: 600px;
  margin: 0 auto;
}
.select-time-con {
  ul {
    position: absolute;
    top: 26px;
    width: 100%;
    border: 1px solid #ccc;
    border-top: 0;
    background: #fff;
    z-index: 2;
  }
}
.select-dock-con {
  .dock-list {
    position: absolute;
    top: 26px;
    width: 100%;
    border: 1px solid #ccc;
    border-top: 0;
    background: #fff;
    z-index: 2;
    max-height: 160px;
    overflow-y: scroll;
  }
}
.select-time-con,
.select-dock-con {
  position: relative;
  vertical-align: top;
  li {
    list-style: none;
    font-size: 14px;
    line-height: 26px;
    color: #4a4a4a;
    border-bottom: 1px solid #ccc;
    padding: 0 4px;
    cursor: pointer;
    &:last-child {
      border-bottom: 0;
    }
    &:hover,
    &.selectActive {
      background: #e42029;
      color: #fff;
    }
  }
}
.select-time,
.select-dock {
  vertical-align: top;
  border: #ccc 1px solid;
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  color: #4a4a4a;
  padding-right: 20px;
  input {
    height: 24px;
    border: 0;
    margin: 0;
    vertical-align: top;
    padding: 0 4px;
    width: 100%;
    color: #4a4a4a;
  }
  i {
    position: absolute;
    top: 0;
    right: 3px;
    display: inline-block;
    height: 26px;
    line-height: 26px;
    vertical-align: top;
    border-left: #ccc 1px solid;
    &:before {
      font-size: 8px;
      margin-left: 4px;
      position: relative;
      top: -2px;
    }
  }
  &:first-child {
    border-right: #ccc 1px solid;
  }
}
.invite-detail {
  height: 100vh;
  background: #fff;
  overflow-x: hidden;
  overflow-y: auto;
  .visitor-list-wrapper {
    padding-bottom: 80px;
  }
  .header {
    padding-bottom: 15px;
  }
}
.visitor-list {
  width: 100%;
  padding: 0 20px;
  color: #4a4a4a;
  .view-content {
    margin-top: 20px;
  }
  h4 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 0;
  }
  .visitor-row {
    border-radius: 4px;
    background: #fff;
    font-size: 13px;
    box-shadow: 0 0 15px rgba(100, 100, 100, 0.1);
    position: relative;
    margin-bottom: 20px;
    line-height: 1;
    .row {
      font-size: 13px;
      line-height: 20px;
      color: #434343;
      margin-bottom: 8px;
      .l {
        color: #929292;
      }
      .red {
        color: #e42029;
      }
    }
    .detail-info {
      padding: 15px 20px;
    }
  }
}
.visitor-content {
  .view-main {
    box-shadow: 0 15px 0px rgba(100, 100, 100, 0.1);
    padding: 0 80px 20px 0;
  }
}
.visitor-content.hide-visitor {
  padding-bottom: 0;
  .view-main {
    border-radius: 10px;
    // padding-bottom: 5px;
    margin-bottom: 20px;
    box-shadow: 0 10px 25px rgba(100, 100, 100, 0.1);
  }
}
.handle-bar {
  background: #fff;
  padding: 15px 20px;
  box-shadow: 0 0 15px rgba(100, 100, 100, 0.15);
  align-items: center;
  .btn {
    width: 100%;
  }
  .refuse {
    cursor: pointer;
    padding-right: 10px;
    .btn {
      &:hover {
        color: #9b9b9b;
      }
    }
  }
  .approve {
    cursor: pointer;
    padding-left: 0.1em;
    padding-right: 0.1em;
  }
}
</style>
